import * as React from "react";
const DownloadIcon = (props) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.9999 17.3333L7.58325 11.9167L9.09992 10.3458L11.9166 13.1625V4.33334H14.0833V13.1625L16.8999 10.3458L18.4166 11.9167L12.9999 17.3333ZM6.49992 21.6667C5.90409 21.6667 5.3942 21.4547 4.97025 21.0308C4.54631 20.6068 4.33397 20.0966 4.33325 19.5V16.25H6.49992V19.5H19.4999V16.25H21.6666V19.5C21.6666 20.0958 21.4546 20.6061 21.0307 21.0308C20.6067 21.4554 20.0965 21.6674 19.4999 21.6667H6.49992Z"
      fill="white"
    />
  </svg>
);
export default DownloadIcon;
